// @ts-ignore
import SubscribeAndSave from '../images/subscribe-and-save.png'

export const widgetThumbnails = {
  'square-subscription-checkout-button': SubscribeAndSave,
}
